import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Cliente } from 'src/app/shared/model/ajustesUsuario/cliente.model';
import { MatFormField, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-showusuariosmodal',
    standalone: true,
    templateUrl: './showusuariosmodal.component.html',
    styleUrls: ['./showusuariosmodal.component.css'],
    imports: [MatFormField, MatInput, FormsModule, MatButton]
})
export class ShowusuariosmodalComponent implements OnInit {

  usuarioCliente = new Cliente();

  constructor(public dialogRef: MatDialogRef<ShowusuariosmodalComponent>, @Inject(MAT_DIALOG_DATA) private dataUser: Cliente) { }

  ngOnInit() {
    this.usuarioCliente = this.dataUser;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  
}
